module.exports = __webpack_public_path__ + "img/PassionVista.81d7f1f7.jpg";